import { render, staticRenderFns } from "./EFile.vue?vue&type=template&id=b6ef66f6&scoped=true&"
import script from "./EFile.vue?vue&type=script&lang=js&"
export * from "./EFile.vue?vue&type=script&lang=js&"
import style0 from "./EFile.vue?vue&type=style&index=0&id=b6ef66f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ef66f6",
  null
  
)

export default component.exports